var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79785 16.1984L16.1945 7.80176",
    stroke: "#3E45EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58577 12.0176C8.08278 11.9887 7.57934 12.0663 7.10844 12.2454C6.63754 12.4246 6.20981 12.7012 5.85327 13.0572L4.054 14.8565C3.37913 15.5314 3 16.4467 3 17.4011C3 17.8736 3.09308 18.3416 3.27393 18.7782C3.45477 19.2148 3.71984 19.6115 4.054 19.9456C4.38816 20.2798 4.78486 20.5449 5.22146 20.7257C5.65806 20.9066 6.126 20.9996 6.59857 20.9996C7.55298 20.9996 8.46829 20.6205 9.14315 19.9456L10.9424 18.1464C11.2984 17.7898 11.575 17.3621 11.7542 16.8912C11.9334 16.4203 12.011 15.9169 11.982 15.4139",
    stroke: "#3E45EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4071 11.982C15.9101 12.0109 16.4135 11.9333 16.8844 11.7541C17.3553 11.575 17.783 11.2984 18.1396 10.9424L19.9389 9.14315C20.6137 8.46829 20.9929 7.55298 20.9929 6.59857C20.9929 5.64417 20.6137 4.72886 19.9389 4.054C19.264 3.37913 18.3487 3 17.3943 3C16.4399 3 15.5246 3.37913 14.8497 4.054L13.0505 5.85327C12.6953 6.21024 12.4195 6.63814 12.241 7.109C12.0626 7.57987 11.9855 8.08309 12.0149 8.58577",
    stroke: "#3E45EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.731a26587cc22fcb05114ce5708070a1.svg";
export { ForwardRef as ReactComponent };